import { useRouter } from 'next/router';
import React, { memo, useMemo } from 'react';

import { useCopyStore } from 'store';
// import {
//   setCursorLabel,
//   triggerDefaultCursor,
//   triggerLightCursor,
// } from 'utils/cursorController';
import { AspectRatio, MediaCMS } from 'utils/sharedStrapiQueries/sharedTypes';
import { colors } from 'utils/styles/theme';

import { formatDate } from './InsightsTile.utils';

import * as S from './InsightsTile.styles';

export interface InsightsTileProps {
  media: MediaCMS;
  mediaType: 'image' | 'video';
  videoErrorMessage?: string;
  videoType?: { autoplay: boolean; mute: boolean };
  aspectRatio: AspectRatio;
  heading: string;
  description: string;
  tag: string;
  cursorLabelRead?: string;
  writingDate: string;
}

const InsightsTile: React.FunctionComponent<InsightsTileProps> = ({
  media,
  mediaType,
  videoErrorMessage,
  videoType,
  aspectRatio,
  heading,
  description,
  tag,
  // cursorLabelRead,
  writingDate,
  ...rest
}) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);
  const router = useRouter();
  const formatedDate = useMemo(() => {
    const replacedDateString = writingDate?.replace(/-/g, '/');
    return formatDate(new Date(replacedDateString), router.locale || 'en');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [writingDate]);

  // const handleMouseEnter = () => {
  //   setIsHovering(true);
  //   setCursorLabel('Click');
  //   triggerLightCursor();
  // };

  // const handleMouseLeave = () => {
  //   setIsHovering(false);
  //   setCursorLabel('');
  //   triggerDefaultCursor();
  // };

  const renderTypeOfMedia = (mediaType: 'image' | 'video') => {
    switch (mediaType) {
      case 'image':
        return (
          <S.Image
            src={media.formats?.small?.url}
            alt={media.alternativeText}
            loading="lazy"
          />
        );
      case 'video':
        return (
          <S.Video
            muted={videoType?.mute}
            loop
            autoPlay={videoType?.autoplay}
            preload="auto"
            playsInline
          >
            <source src={media.url} type="video/mp4" />
            {videoErrorMessage || ''}
          </S.Video>
        );
      default:
        return null;
    }
  };

  const textColor =
    globalSettings?.buttonsHoverColor ||
    globalSettings?.buttonsHoverDefaultColors;

  return (
    <S.InsightsTileWrapper textColor={textColor} {...rest}>
      <S.MediaContainer
        aspectRatio={aspectRatio}
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
      >
        {renderTypeOfMedia(mediaType)}
      </S.MediaContainer>

      <S.TextContainer>
        <S.BottomTextContainer>
          <S.Tag size="small" color={colors.white} text={tag} />
          <div>
            <S.Heading size="heading5" text={heading} textColor={textColor} />
          </div>
          <S.Description size="smallBody" text={description} />
          <S.Date size="small" text={formatedDate} />
        </S.BottomTextContainer>
      </S.TextContainer>
    </S.InsightsTileWrapper>
  );
};

export default memo(InsightsTile);
